import HomePage from "@/components/pages/HomePage";
import { getLocalizedHome } from "@/lib/i18n/content";

const Home = () => <HomePage content={getLocalizedHome("en")} locale="en" path="/" />;

export default Home;
